import { addonInputTypes } from 'src/helpers/addons/addon_helpers';

export const getChartIcon = (type: string): string | null => {
	switch (type) {
		case 'consumption':
			return 'fas fa-plug';
		case 'ppm':
			return 'fas fa-siren';
		case 'humidity':
			return 'fas fa-humidity';
		case 'pressure':
			return 'fas fa-gauge';
		case 'precipitation':
			return 'fas fa-cloud-rain';
		case 'illuminance':
			return 'fas fa-sun-bright';
		case 'uv':
			return 'fas fa-sun';
		case 'wind_speed':
			return 'fas fa-wind';
		case 'voltage':
			return 'fas fa-bolt';
		case 'distance':
			return 'fas fa-ruler-horizontal';
		case 'freq_measurement':
			return 'fas fa-wave-square';
		case 'counter_accumulation':
			return 'far fa-gauge-circle-plus';
		default:
			return addonInputTypes[type]?.icon || null;
	}
};
